import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Pen({
  color = 'icon.primary',
  fill = 'transparent',
  stroke = 1.5,
  ...props
}) {
  return (
    <IconBase viewBox='0 0 15 15' {...props}>
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.27185 10.8449L10.8526 1.27119C11.2144 0.909603 11.8017 0.909603 12.1636 1.27119L13.7186
           2.82508C14.0805 3.18667 14.0805 3.77355 13.7186 4.13514L4.13698 13.7079C3.96347 13.8822 3.72781
           13.9796 3.48193 13.9796H1V11.4994C1 11.2538 1.09742 11.0183 1.27185 10.8449Z'
        stroke={color}
        fill={fill}
        strokeWidth={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M9.11719 2.99609L11.9842 5.86097'
        stroke={color}
        fill={fill}
        strokeWidth={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

Pen.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
  stroke: PropTypes.number,
}

export default Pen
